import axios from 'axios'
import {API_VERSION, BASE_URI_API} from '@/configs/api'

export default {
    send({commit}, formData){  
        commit('SET_PRELOADER', true)
        commit('SET_TEXT_PRELOADER', 'A enviar postal de natal')      
        return axios.post(`${BASE_URI_API}${API_VERSION}/send-email`, formData).finally(() => commit('SET_PRELOADER', false))
    },
}

